import type { MailboxInfo } from 'owa-client-types';
import { isSharedCoprincipalAccountEnabled } from './isSharedCoprincipalAccountEnabled';
import { isMailboxSharedOrDelegateUserMailbox } from './isMailboxSharedOrDelegateUserMailbox';
import { isAccountExplicitLogon } from './isAccountExplicitLogon';
import { isMailboxSharedResourceArchive } from './isMailboxSharedArchive';
import { isFeatureEnabled } from 'owa-feature-flags';

/**
 * Returns true if the mailbox is shared or a delegate mailbox either the main user mailbox
 * of the account or an other mailbox in the account.
 */
export function isMailboxSharedOrDelegate(mailboxInfo: MailboxInfo): boolean {
    if (mailboxInfo.type === 'UserMailbox') {
        return isSharedCoprincipalAccountEnabled()
            ? isMailboxSharedOrDelegateUserMailbox(mailboxInfo)
            : isAccountExplicitLogon(mailboxInfo);
    }

    if (mailboxInfo.type === 'ArchiveMailbox') {
        if (isFeatureEnabled('fp-archive-shared-mailboxes')) {
            return (
                isAccountExplicitLogon(mailboxInfo) || isMailboxSharedResourceArchive(mailboxInfo)
            );
        } else {
            return false;
        }
    }

    return mailboxInfo.type === 'SharedMailbox';
}
